<template>
	<div class="nav">
		<div class="nav-modal" @click="nav"></div>
		<img src="../img/ic27.png" @click="nav" />
		<div class="nav-list">
			<div @click="about(0)" class="font-2">
				返回首页
			</div>
			<div @click="about(1)">
				<h1 class="font-2">百年厦大</h1>
				<p class="font-3">厦门大学庆祝建校100周年形象片</p>
			</div>
			<div @click="about(2)">
				<h1 class="font-2">陈嘉庚与百年厦大</h1>
				<p class="font-3">
					中央广播电视总台中文国际频道<br />
					“国家记忆”栏目大型纪录片
				</p>
			</div>
			<div @click="about(3)">
				<h1 class="font-2">南方之强</h1>
				<p class="font-3">厦门大学庆祝建校100周年文艺晚会</p>
			</div>
			<div @click="about(4)">
				<h1 class="font-2">凤凰花季</h1>
				<p class="font-3" v-html="'歌&emsp;&emsp;曲'"></p>
			</div>
			<div @click="about(5)">
				<h1 class="font-2">相聚在美丽的校园</h1>
				<p class="font-3" v-html="'歌&emsp;&emsp;曲'"></p>
			</div>
		</div>
	</div>
</template>
<script>
import $ from "jquery";
export default{
	name: 'jm-wap-nav',
	methods: {
		about(index){
			if(index == 0)
				this.$router.push({ path:'/'});
			else
				this.$router.push({ path:'/About/' + index + '.html'});
		},
		nav(){
			if($('.nav img').css('right') == '0px'){
				$('.nav-modal').show()
				$(".nav img").stop(true,true).animate({right:"13rem"});
				$(".nav-list").stop(true,true).animate({right:0});
			}else{
				$('.nav-modal').hide()
				$(".nav img").stop(true,true).animate({right:0});
				$(".nav-list").stop(true,true).animate({right:"-13rem"});
			}
		}
	}
}
</script>
<style scoped>
.nav img{
	display: flex;
	width: 1.55rem;
	position: fixed;
	right: 0;
	top: 30%;
	margin-top: -.775rem;
	z-index: 999;
}
.nav-list{
	color: #c6af7b;
	background-color: #d7412a;
	width: 13rem;
	position: fixed;
	right: 0;
	top: 30%;
	margin-top: -2.025rem;
	padding: 0 .8rem;
	padding-top: 1.125rem;
	border-radius: .15rem;
	right: -13rem;
	z-index: 999;
}
.nav-list div{
	border-radius: .15rem;
	height: 2.425rem;
	border:1px solid #c6af7b;
	margin: 0 auto;
	margin-bottom: 1.125rem;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.nav-list h1{
	font-size: 1.2rem;
}
.nav-list div:nth-child(1){
	font-size: 1.2rem;
	align-items: center;
	justify-content: center;
}
.nav-list div:nth-child(3) h1{
	margin: 0;
	font-size: .9rem;
}
.nav-list div:nth-child(3) p{
	margin: 0;
}
.nav-list p{
	font-size: .7rem;
	margin-top: .1rem;
}
.nav-modal{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	display: none;
}
</style>